import {useState} from 'react';
import axios from "axios";
import { Formik, Form } from "formik";
import { Input } from "../TextField/TextField";
import * as Yup from "yup";
import { Link, useHistory, useParams } from "react-router-dom";
import Header from "../../layout/Header/Header";
import { config } from '../../Constant'
import { ErrorToast, SuccessToast } from "../Toast/Toast";
import Button from "../Button/Button";
import LoadingModal from '../../layout/LoadingModal/LoadingModal';

const SetPassword = () => {
	const {token} = useParams();
	const [modalShow, setModalShow] = useState(false);
	const history = useHistory();
	const validate = Yup.object({
		password: Yup.string()
			.min(6, "Password must be at least 6 characters")
			.required("Password is required"),
		confirmPassword: Yup.string()
			.oneOf([Yup.ref("password"), null], "Password must match")
			.required("Confirm password is required"),
	});

	if (!token) {
		history.push("/");
	}

	return (
		<Formik
			initialValues={{
				password: "",
				confirmPassword: "",
			}}

			validationSchema={validate}
			onSubmit={(values) => {
				values.token = token;
				console.log(values)
				setModalShow(true);
				axios
					.post(
						`${config.url.API_URL}/AdminDashboard/admindashboard.php/updateTeacherPassword`,
						values
					)
					.then((res) => {
						setModalShow(false);
						if (res.status === 200) {
							SuccessToast(res.data.message);
							history.push("/parentslogin");
						} else {
							ErrorToast(res.data.error);
						}
					})
					.catch(function (error) {
						ErrorToast(error.res.data.error);
						console.log(error);
					});
			}}
		>
			{(formik) => (
				<>
					<Header />
					<LoadingModal show={modalShow} onHide={() => setModalShow(false)} />
					<div className="h-100 reset-password-section justify-content-center align-items-center">
						<div className="container">
							<h2 className="bold mt-3 text-center">
								Update Your Password
							</h2>

							<div className="row mt-4 reset-password">
								<Form className="center-form" style={{width:'100%'}}>
									<div className="mb-4 labelStyle">
										<Input
											label="Password"
											name="password"
											type="password"
											id="form-input"
											placeholder="Please enter your password"
										/>
									</div>
									<div className="mb-4 labelStyle">
										<Input
											label="Confirm Password"
											name="confirmPassword"
											type="password"
											id="form-input"
											placeholder="Please confirm your password"
										/>
									</div>

									<div className="button-div m-auto text-center">
										<Link to="/pricing">
											<Button type='button' title='Back' className="btn mr-3"/>
										</Link>
										<Button type='submit' title='submit' className="btn"/>
									</div>
								</Form>
							</div>
						</div>
					</div>
				</>
			)}
		</Formik>
	);
};

export default SetPassword;